var _excluded = ["className", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import CkIcon from "../private/CkIcon";
import { nanoid } from "nanoid/non-secure";
var UserFilledLg = /*#__PURE__*/React.forwardRef((props, ref) => {
  var _props = _extends({}, props),
    {
      className,
      title
    } = _props,
    rest = _objectWithoutPropertiesLoose(_props, _excluded);
  var titleId = props != null && props.id ? props.id + "-title" : nanoid(5);
  return /*#__PURE__*/React.createElement(CkIcon, _extends({
    className: ["CK__Icon--large", className].filter(Boolean).join(" "),
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": title ? titleId : undefined
  }, rest), title && /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 12c0 3.424-1.564 6.483-4.018 8.5A10.955 10.955 0 0 1 12 23c-2.651 0-5.083-.938-6.982-2.5A10.978 10.978 0 0 1 1 12C1 5.925 5.925 1 12 1s11 4.925 11 11Zm-4.047 7.187A7.001 7.001 0 0 0 12 13a4 4 0 1 0 0-8 4 4 0 0 0 0 8 7.001 7.001 0 0 0-6.953 6.187A9.967 9.967 0 0 0 12 22a9.967 9.967 0 0 0 6.953-2.813Z",
    fill: "currentColor"
  }));
});
UserFilledLg.displayName = "UserFilledLg";
export default UserFilledLg;